import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import axios from "axios";

//axios.defaults.baseURL = "https://db.bongagames.co.ke/api/"; //prod
//axios.defaults.baseURL = "http://localhost:12300/api/"; //dev
// Create an Axios instance for read operations
axios.defaults.baseURL = "https://db.stargames.co.ke/api/";

axios.defaults.withCredentials = true;

const el = document.getElementById('root');

const root = ReactDOM.createRoot(el);

root.render(<App/>);